<template>
  <HScaffold :hideNav="hideNav" title="提现">
    <div style="display:flex;flex-direction: row;align-items: center;margin:10px;justify-content: space-between;">
      <div :style="{
        background: HNewGameUIConfig.newGameUIType === 3?'linear-gradient(to right, black, transparent)':'',
        padding:HNewGameUIConfig.newGameUIType === 3?'5px 30px 5px 10px':'',
        borderTopLeftRadius:'20px',
        borderBottomLeftRadius: '20px',
        display: 'flex',
        flexDirection: 'row',
        alignItems:' center',
      }">
        <div :style="hcf.getTextStyle({
        color:HNewGameUIConfig.newGameUIType === 3? 'white':'#ff7d3f',marginRight:5,fontWeight:'bold',addSize:1
      })">
          我的余额:
        </div>
        <HShowRefreshBalance :moneySize="-3" :imgSize="20" :moneyColor="HNewGameUIConfig.newGameUIType === 3?'main':'#ff7d3f'"/>
      </div>
      <div @click="hr.go('account-detail', {'fromType': 2})" :style="hcf.getTextStyle({color:'main',addSize:-1})">提现历史</div>
    </div>
    <HPayWithdrawContainer title="提现方式" :desc="selectPayChannelItem['Desc']">
      <div ref="scrollContainerRef" class="scrollContentDiv">
        <div style="flex-shrink: 0;flex-direction: column;" v-for="(eachArray,arrayIndex) in allChannelData"
             :key="arrayIndex">
          <div @click="chooseChannelType(item,arrayIndex)"
               :style="{
                  marginTop:index === 1?'15px':'0',
                  backgroundColor:getEachContainerBgColor(selectPayChannelItem['Id'] === item['Id']),
                  border:getEachContainerBorderColor(selectPayChannelItem['Id'] === item['Id']),
               }"
               class="eachScrollDiv"
               v-for="(item,index) in eachArray" :key="item['Id']">
            <HCacheImage :src="item['Icon']" height="30px"/>
            <div
                style="margin-left: 5px;display:flex;flex-direction: column;align-items: flex-start;justify-content: center;width: 100%;">
              <div :style="hcf.getTextStyle({
              addSize:0,color:selectPayChannelItem['Id'] === item['Id']?(HNewGameUIConfig.newGameUIType === 3
                                          ? 'white'
                                          : 'black'):(HNewGameUIConfig.newGameUIType === 3
                                          ? '#aaa'
                                          : '#777'),fontWeight:selectPayChannelItem['Id'] === item['Id']?'bold':'normal'
            })">{{ item['Name'] }}
              </div>
              <div :style="hcf.getTextStyle({
              addSize:-3,color:'#888'
            })">{{
                  (item["MinMoney"] != 0 && item["MaxMoney"] != 0)
                      ? ('单笔' + processKLogic(hcf.getMoneyValue(item["MinMoney"], {saveCount: 0})) + '~' + processKLogic(hcf.getMoneyValue(item["MaxMoney"], {saveCount: 0})) + '元')
                      : "可选固定提现金额"
                }}
              </div>
            </div>
            <img v-if="item['Commend']" :src="icon_flag_hot" style="position:absolute;top:0;left:0;height:26px;" alt="">
            <div v-if="item['AwardDesc']!==''"
                 style="background-color: #f33;padding:0 6px;border-radius: 20px;position:absolute;top:-10px;right:-18px;">
              <div :style="hcf.getTextStyle({
                color:'#fff',addSize:-3
            })">{{ item['AwardDesc'] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </HPayWithdrawContainer>
    <HPayWithdrawContainer title="提现金额">
      <div :style="{
        display:'flex',
        flexDirection: 'column',
      }">
        <div v-if="selectPayChannelItem['MinMoney']!==0 && selectPayChannelItem['MaxMoney']!==0"
             style="border-radius:6px;padding:6px 10px;display:flex;flex-direction: row;align-items: center;">
          <div :style="hcf.getTextStyle({
              addSize:3,
          })">¥
          </div>
          <van-field
              :style="{
                fontSize:'14px',
                backgroundColor:'#0000',
              }"
              maxlength="10"
              type="number"
              v-model="withdrawMoneyValue"
              placeholder="请输入提现的金额"
              @input="onInput()"
              @blur="checkMaxMinValue"
              @change="checkMaxMinValue"
          >
            <template #button>
              <div @click="clickAllWithdraw" :style="hcf.getTextStyle({
                color:'main'
              })">
                全部提现
              </div>
            </template>
          </van-field>
        </div>
        <van-divider style="margin:0 0 8px 0"/>
        <div style="">
          <div @click="clickAllWithdraw" :style="hcf.getTextStyle({
                color:'#aaa',addSize:-1
              })">
            {{ `可提现金额 ¥${useUser.availableMoney} (剩余还需投注${needBetMoney}元)` }}
          </div>
        </div>
      </div>
    </HPayWithdrawContainer>
    <HPayWithdrawContainer title="收款方式">
      <div v-if="selectWithdrawTypeData == null" @click="clickGoWithdrawMgr"
           :style="{
              backgroundColor:hcf.getMainColor()+'1a',
           }" class="chooseWithdrawTypeDiv">
        <div :style="hcf.getTextStyle({
            color:'#f33',addSize:-1
          })">未绑定过此提现方式
        </div>
        <div style="display:flex;flex-direction: row;align-items: center;">
          <div :style="hcf.getTextStyle({
            color:'#f33',addSize:-2
          })">前往绑定
          </div>
          <van-icon name="arrow" size="16" color="#f33"/>
        </div>
      </div>
      <div v-if="selectWithdrawTypeData != null" @click="clickGoChooseWithdraw"
           :style="{
              backgroundColor:hcf.getMainColor()+'1a',
           }" class="chooseWithdrawTypeDiv">
        <div style="display: flex;flex-direction: row;align-items: center;">
          <HCacheImage :src="selectPayChannelItem['Icon']" height="20px" width="20px"/>
          <div :style="hcf.getTextStyle({
              marginLeft:6,addSize:-1
          })">
            {{ selectWithdrawTypeData["BankName"] }}
          </div>
          <div :style="hcf.getTextStyle({
              marginLeft:10,addSize:-3,color:'#666'
          })">
            (尾号{{
              selectWithdrawTypeData["BankCard"].slice(selectWithdrawTypeData["BankCard"].length - 4, selectWithdrawTypeData["BankCard"].length)
            }})
          </div>
        </div>
        <div style="display:flex;flex-direction: row;align-items: center;">
          <div :style="hcf.getTextStyle({
            color:'#888',addSize:-2
          })">
            更换{{ selectPayChannelItem["Name"] }}
          </div>
          <van-icon name="arrow" size="16" color="#888"/>
        </div>
      </div>
      <div style="margin-top: 20px;display:flex;flex-direction: row;align-items: center;justify-content: space-between;">
        <div :style="hcf.getTextStyle({
            color:'#777'
        })">
          到账金额(元): {{getTureDoneMoney(selectPayChannelItem)}}
        </div>
        <div :style="hcf.getTextStyle({
            color:'#777'
        })">
          {{selectPayChannelItem["FeeValue"] === 0 ? "免手续费" : `手续费 ${selectPayChannelItem["FeeValue"]}%`}}
        </div>
      </div>
      <HButton margin="20px 0 10px 0" :callback="requestWithdraw" :disabled="!isCanGo" title="提现"/>
      <div @click="()=>{
        useHComApi().openService();
      }" style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
        <div :style="hcf.getTextStyle({
        color:'#aaa',marginRight:5,
      })">
          遇到提现问题，请联系
        </div>
        <div :style="hcf.getTextStyle({
        color:'main',marginRight:5
      })">
          在线客服
        </div>
      </div>
    </HPayWithdrawContainer>
    <div :style="hcf.getTextStyle({
        marginTop:10,color:'#aaa',marginLeft:10,marginRight:10,addSize:-2
      })">{{ noticeStr }}
    </div>
    <van-action-sheet :closeable="false" v-model:show="showSelectModal"
                      style="height:53%;background-color: var(--ct-main-bg-color)">
      <template #description>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="width:50%"/>
          <div style="width:50%">
            <div :style="hcf.getTextStyle({
              addSize:2
            })">选择{{ selectPayChannelItem['Name'] }}
            </div>
          </div>
          <div @click="clickGoWithdrawMgr" style="width:50%;display:flex;flex-direction:row;justify-content: flex-end;">
            <div :style="hcf.getTextStyle({
              color:'main',textAlign:'right'
            })">去管理
            </div>
          </div>
        </div>
      </template>
      <div @click="clickSelect(item)" v-for="item in selectWidthDrawTypeList" :key="item.label"
           style="justify-content:space-between;border-radius: 5px;margin:10px;display:flex;flex-direction: row;align-items: center;padding:13px;background-color: white;">
        <div style="flex-shrink: 0;display: flex;flex-direction: row;align-items: center;">
          <HCacheImage :src="selectPayChannelItem['Icon']" height="20px" width="20px"/>
          <div :style="hcf.getTextStyle({
              marginLeft:6,addSize:-1
          })">
            {{ item["BankName"] }}
          </div>
          <div :style="hcf.getTextStyle({
              marginLeft:10,addSize:-3,color:'#666'
          })">
            (尾号{{ item["BankCard"].slice(item["BankCard"].length - 4, item["BankCard"].length) }})
          </div>
        </div>
        <div v-if="selectWithdrawTypeData!=null" style="display:flex;flex-direction: row;align-items: center;">
          <van-checkbox :checked="item['Id'] === selectWithdrawTypeData['Id']" icon-size="16px"/>
        </div>
      </div>
    </van-action-sheet>
  </HScaffold>
</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {hr} from "@/components/utils/HRouter.js";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import icon_flag_hot from "@/assets/icons/common/flag_hot.png";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {ref} from "vue";
  import {showDialog, showToast} from "vant";
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import HButton from "@/components/utils/HButton.vue";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import HShowRefreshBalance from "@/components/utils/HShowRefreshBalance.vue";

  defineProps(["hideNav"]);

  let useUser = useUserStore();
  let useHttp = useHHttp();
  const showSelectModal = ref(false);

  const selectPayChannelItem = ref({id: 0,FeeValue:0});
  const noticeStr = ref("");
  const needBetMoney = ref(0);//元
  const allChannelData = ref([]);
  const scrollContainerRef = ref();
  const withdrawMoneyValue = ref("");
  const selectWithdrawTypeData = ref(null);
  const selectWidthDrawTypeList = ref([]);
  const isCanGo = ref(false);

  function getEachContainerBgColor(isSelect){
    if(HNewGameUIConfig.newGameUIType === 3){
      if(isSelect){
        return "#3F362E";
      }else{
        return "#191B15";
      }
    }else{
      return "#f7f7f7";
    }
  }
  function getEachContainerBorderColor(isSelect){
    if(isSelect){
      return "var(--ct-main-color) 2px solid";
    }else{
      if(HNewGameUIConfig.newGameUIType === 0){
        return "#f7f7f7 2px solid";
      }else if(HNewGameUIConfig.newGameUIType === 3){
        return "#333333 2px solid";
      }else{
        return "#fafafaaa 2px solid";
      }
    }
  }
  function getTureDoneMoney(data){
    let feeValue = data["FeeValue"];
    if (withdrawMoneyValue.value.trim() !== "") {
      let rate = (100 - feeValue) / 100;
      return (parseFloat(withdrawMoneyValue.value) * rate).toFixed(2);
    } else {
      return "";
    }
  }

  function requestWithdraw() {
    //需要实名
    let isNeedName = selectPayChannelItem.value["NeedName"] ?? false;
    if (isNeedName && useUser.realName === "") {
      showDialog({
        title: '充值提醒',
        message: "当前支付渠道需要先进行实名",
        cancelButtonText: "暂不",
        showCancelButton: true,
        confirmButtonText: "去实名",
        confirmButtonColor: hcf.getMainColor()
      }).then(() => {
        hr.go("editor", {
          "hintText": "姓名必须与银行持卡人一致",
          "title": "设置真实姓名",
          "successCallBack": (value) => {
            useHttp.request("/app/profile/modify-base", () => {
              showToast("实名成功");
              useUser.realName = value;
              hr.goBack();
            }, {
              params: {
                "AppId": useUser.appId,
                "UserId": useUser.userId,
                "RealName": value,
              }
            });
          }
        });
      }).catch(() => {
      });
    } else {
      let withdrawType = parseInt(getWithdrawType());
      // 暂时不需要交易密码
      // Global.showInputPwdModal((pwd){
      useHttp.request("/qp/withdraw/order/create2", () => {
        showToast("提现申请已提交");
        const api = useHComApi();
        api.refreshUserBalance();
        api.fetchRedDot();
        hr.goOff("account-detail", {"fromType": 2});
      }, {
        params: {
          "WithDrawMethod": withdrawType,
          "WithDrawMoney": Math.floor(withdrawMoneyValue.value) * 100,
          "AccountRealName":
              withdrawType === 1 || withdrawType === 3 || withdrawType === 4
                  ? selectWithdrawTypeData.value["RealName"]
                  : useUser.realName,
          "AccountNumber": selectWithdrawTypeData.value["BankCard"],
          "BankName": selectWithdrawTypeData.value["BankName"],
        }
      });
    }
  }

  function clickSelect(item) {
    selectWithdrawTypeData.value = item;
    showSelectModal.value = false;
  }

  function clickGoChooseWithdraw() {
    showSelectModal.value = true;
  }

  function clickGoWithdrawMgr() {
    if (selectWithdrawTypeData != null) {
      hcf.saveLastActiveTabType = selectPayChannelItem.value["Type"];
    }
    hr.go('bind_card');
  }

  function clickAllWithdraw() {
    withdrawMoneyValue.value = useUser.availableMoney;
    checkMaxMinValue();
    checkIsCanGoWithdraw();
  }

  function onInput() {
    checkIsCanGoWithdraw();
  }

  function checkMaxMinValue() {
    if (withdrawMoneyValue.value === "") {
      return;
    }
    let intMoneyValue = parseInt(withdrawMoneyValue.value);
    let availableValue = parseFloat(useUser.availableMoney);
    let minMoney = Math.floor(selectPayChannelItem.value["MinMoney"] / 100);
    let maxMoney = Math.floor(selectPayChannelItem.value["MaxMoney"] / 100);
    if (intMoneyValue < minMoney) {
      withdrawMoneyValue.value = minMoney + "";
      showToast("提现金额不可小于 " + minMoney);
    }
    if (intMoneyValue > maxMoney) {
      withdrawMoneyValue.value = maxMoney + "";
      showToast("提现金额不可大于 " + maxMoney);
    }
    if (intMoneyValue > availableValue) {
      withdrawMoneyValue.value = availableValue + "";
      showToast("最大可提现余额 " + availableValue);
    }
  }

  function processKLogic(numberStr) {
    const number = parseInt(numberStr) || 0;

    if (number < 1000) {
      return numberStr;
    } else if (number >= 10000) {
      const result = number / 10000;
      return Number.isInteger(result)
          ? `${parseInt(result + '')}万`
          : `${result.toFixed(1)}万`;
    } else {
      const result = number / 1000;
      return Number.isInteger(result)
          ? `${parseInt(result + '')}千`
          : `${result.toFixed(1)}千`;
    }
  }

  function scrollToCenter(index, isAnimate = true) {
    let targetYValue = 155 * (index - 1) + 50;
    if (isAnimate) {
      scrollContainerRef.value.scrollTo({
        left: targetYValue,
        behavior: 'smooth'
      });
    } else {
      scrollContainerRef.value.scrollLeft = targetYValue;
    }
  }

  function checkIsCanGoWithdraw() {
    isCanGo.value = selectPayChannelItem.value != null && selectWithdrawTypeData.value != null && withdrawMoneyValue.value !== "";
  }

  function chooseChannelType(item, index) {
    selectPayChannelItem.value = item;
    withdrawMoneyValue.value = "";
    scrollToCenter(index);
    setDefaultWithdrawType();
    checkIsCanGoWithdraw();
  }

  function getWithdrawType() {
    let targetTypeStr = null;
    const allTypeInfo = hcf.withdrawTypeList;
    for (let i = 0; i < allTypeInfo.length; i++) {
      if (selectPayChannelItem.value["Type"] === allTypeInfo[i]["type"]) {
        targetTypeStr = allTypeInfo[i]["type"] + "";
        break;
      }
    }
    if(targetTypeStr == null){
      showToast(`当前版本未支持【${selectPayChannelItem.value["Name"]}】方式\n请升级版本或联系客服`)
    }
    return targetTypeStr;
  }

  function setDefaultWithdrawType() {
    selectWithdrawTypeData.value = null;
    if (selectPayChannelItem.value == null) {
      return;
    }
    let targetTypeStr = getWithdrawType();

    if (targetTypeStr != null) {
      let tDataList = useUser.withdrawMap[targetTypeStr];
      if (tDataList && tDataList.length > 0) {
        selectWidthDrawTypeList.value = tDataList;
        for (let i = 0; i < tDataList.length; i++) {
          if (tDataList["Default"]) {
            selectWithdrawTypeData.value = tDataList[i];
            break;
          }
        }
        if (selectWithdrawTypeData.value == null) {
          selectWithdrawTypeData.value = tDataList[0];
        }
      }
    }
  }


  onMounted(() => {
    useHttp.request("/qp/withdraw/type/list", (data) => {
      noticeStr.value = data["Notice"].replaceAll("/n", '\n');
      needBetMoney.value = data["NeedBetMoney"];
      let targetCount = data["Channels"].length % 2 !== 0 ? (Math.floor(data["Channels"].length / 2) + 1) : (Math.floor(data["Channels"].length / 2));
      for (let i = 0; i < targetCount; i++) {
        if (i * 2 + 1 >= data["Channels"].length) {
          allChannelData.value.push([
            data["Channels"][i * 2],
          ]);
        } else {
          allChannelData.value.push([
            data["Channels"][i * 2],
            data["Channels"][i * 2 + 1],
          ]);
        }
      }
      selectPayChannelItem.value = data["Channels"][0];
      setDefaultWithdrawType();
    });
  });

</script>


<style scoped>
  .chooseWithdrawTypeDiv {
    justify-content: space-between;
    border-radius: 3px;
    padding: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
  }

  .eachScrollDiv {
    flex-shrink: 0;
    display: flex;
    margin-right: 20px;
    border-radius: 8px;
    padding: 2px 8px;
    height: 45px;
    flex-direction: row;
    align-items: center;
    background-color: #f7f7f7;
    border: #f3f3f3 2px solid;
    position: relative;
  }

  .scrollContentDiv {
    padding-top: 10px;
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* iOS 流畅滚动 */
  }
</style>
